module.exports = __webpack_public_path__ + "static/media/calendar.a2c867f3.png";